import { Plan } from "../../interfaces/Consultancy";
import i18n from "../../i18n/i18n";

type DateInput = string | number | Date;

function toDate(value: DateInput): Date {
    if (value instanceof Date) return value;
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
        const [y, m, d] = value.split('-').map(Number);
        return new Date(y, m - 1, d);
    }
    return new Date(value);
}

export function formatDate(
    value: DateInput,
    locale: string = i18n.language || navigator.language || 'it-IT',
    options: Intl.DateTimeFormatOptions = { dateStyle: 'medium' }
): string {
    const date = toDate(value);
    if (Number.isNaN(date.getTime())) return '';

    const formatter = new Intl.DateTimeFormat(locale, options);
    return formatter.format(date);
}

export const getPlanColor = (plan: Plan) => {
    switch (plan) {
        case Plan.FREE:
            return { backgroundColor: '#f4c2c2', color: '#FFFFFF' };
        case Plan.LIGHT:
            return { backgroundColor: '#b0e0e6', color: '#FFFFFF' };
        case Plan.PLUS:
            return { backgroundColor: '#d8bfd8', color: '#FFFFFF' };
        default:
            return { backgroundColor: '#F5F5F5', color: '#FFFFFF' };
    }
};

export const getPlanLabel = (plan: Plan) => {
    switch (plan) {
        case Plan.FREE:
            return 'Free';
        case Plan.LIGHT:
            return 'Light';
        case Plan.PLUS:
            return 'Plus';
        default:
            return plan;
    }
};

export const buttonStyle = {
    cursor: 'pointer',
    backgroundColor: '#E9495A',
    color: '#FFFFFF',
    '&:hover': {
        backgroundColor: '#E6263B'
    }
}